var map = {
	"./background1.jpg": 2325,
	"./background2.jpg": 6074,
	"./background3.jpg": 1911,
	"./background4.jpg": 5916,
	"./background5.jpg": 6969,
	"./background6.jpg": 9854
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2220;